import { MotivoNotificacao } from "@/contexts/laboratorio/motivoNotificacao/model/MotivoNotificacao";
import { api } from "@/shared/api/api";

export const createMotivoNotificacaoApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const listAll = async () => {
    const { data } = await api.get<MotivoNotificacao[]>(
      "/motivos-notificacao/todos",
      { headers }
    );
    return data;
  };

  return { listAll };
};
